import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { colors } from "@/theme";
import { SectionTitle, Spinner } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";

export default function Collections() {
  const [collections, setCollections] = useState(null);
  const isMobile = useIsMobile();
  useEffect(() => { api("/collections").then(setCollections).catch(() => setCollections([])); }, []);

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px" }}>
      <SectionTitle eyebrow="Curated Worlds" title="Collections" subtitle="Considered edits for every corner of the home." />
      {collections === null ? <Spinner /> : (
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)", gap: isMobile ? 18 : 28 }}>
          {collections.map((c) => (
            <Link key={c.id} to={`/collection/${c.id}`} data-testid={`collection-${c.id}`} className="card-hover" style={{ textDecoration: "none", position: "relative", display: "block", overflow: "hidden", border: `1px solid ${colors.border}` }}>
              <div style={{ aspectRatio: isMobile ? "3 / 2" : "16 / 10", overflow: "hidden" }}>
                <img src={c.image} alt={c.name} className="card-img" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              </div>
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, transparent 40%, rgba(44,41,37,0.62) 100%)" }} />
              <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, padding: 24 }}>
                <h3 className="font-display" style={{ color: "#FCFBF8", margin: 0, fontSize: 28, fontWeight: 700 }}>{c.name}</h3>
                <p className="font-body" style={{ color: "rgba(252,251,248,0.9)", margin: "4px 0 0", fontSize: 14 }}>{c.tagline}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
